import { SET_CALL_VIEW, SET_CALL_REGISTRATION } from '../../../helpers/action-types';

export function setCallView(view) {
    return {
        type: SET_CALL_VIEW,
        view
    };
}

export function setCallRegistration(registration) {
    return {
        type: SET_CALL_REGISTRATION,
        registration
    };
}